/* TATUM only. Adds notes beside existing YMQ fields; does not replace options or prices. */
(() => {
  if (!location.pathname.includes('/products/tatum-modular-splicing-motorized-curtain-track') && !document.documentElement.hasAttribute('data-tatum-local-preview')) return;
  const field = label => document.querySelector(`.ymq-options-box[ymq-option-label="${label}"]`);
  let previous = '';
  let queued = false;
  const value = box => box?.querySelector('input:checked')?.value || box?.querySelector('.ymq-option-title-right-name')?.textContent?.trim() || '';
  function add(box, id, html) {
    let node = document.getElementById(id);
    if (!node) { node = document.createElement('div'); node.id = id; node.className = 'tatum-option-note'; node.innerHTML = html; box.append(node); }
    return node;
  }
  function update() {
    queued = false;
    const length = field('Length (inch)'), power = field('Power Type'), control = field('Control Method');
    if (!length || !power || !control) return;
    const size = value(length), supply = value(power), large = size.includes('320'), plug = supply === 'Plug-in';
    const dual = add(length, 'tatum-dual-note', 'Includes two motors, one at each end.');
    dual.hidden = !large;
    const outlets = add(power, 'tatum-outlet-note', '<p>Requires a power outlet at each end.</p><label class="tatum-outlet-confirm"><input type="checkbox" id="tatum-outlets-confirmed" aria-describedby="tatum-outlet-error"> <span>I have an outlet at each end. <span aria-hidden="true">*</span></span></label><p id="tatum-outlet-error" role="alert" hidden>Please confirm power outlets at both ends before adding to cart.</p>');
    const check = outlets.querySelector('input');
    const combination = size + '|' + supply;
    if (combination !== previous) {check.checked = false; previous = combination; document.getElementById('tatum-outlet-error').hidden = true;}
    outlets.hidden = !(large && plug);
    check.disabled = !large || !plug;
    check.required = large && plug;
    check.setAttribute('aria-required', String(check.required));
    const productForm = length.closest('product-form')?.querySelector('form.js-product-form');
    const formId = productForm?.getAttribute('id');
    if (formId) check.setAttribute('form', formId);
    if (check.checked) document.getElementById('tatum-outlet-error').hidden = true;
    add(control, 'tatum-remote-note', '<p>Single-channel remote included.</p>');
    const mounting = field('Mounting Type'), warranty = field('保障');
    if (mounting && warranty) {
      const inputs = mounting.querySelectorAll('input[type="radio"]');
      // Keep the existing selected value for YMQ/order data. Only collapse a fixed choice.
      const fixed = inputs.length === 1 && inputs[0].checked && inputs[0].value.trim() === 'Ceiling & Wall Mount Compatible';
      mounting.classList.toggle('tatum-fixed-mounting', fixed);
      const compatibility = add(warranty, 'tatum-compatibility-note', '<p data-tatum-mounting><svg class="tatum-benefit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 20V4h16M8 4v5h8M4 13h5v7"/><path d="M13 9v4m-4 4h4"/></svg><span>Ceiling and wall mount compatible</span></p><p><svg class="tatum-benefit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 4h18M5 4v16h14V4M9 5v14M15 5v14M5 20q3-2 7 0 4-2 7 0"/></svg><span>Fits Ripple Fold &amp; Pleated Drapery</span></p>');
      compatibility.querySelector('[data-tatum-mounting]').hidden = !fixed;
      if (warranty.firstElementChild !== compatibility) warranty.prepend(compatibility);
    }
  }
  function gate(event) {
    const note = document.getElementById('tatum-outlet-note'), check = document.getElementById('tatum-outlets-confirmed');
    if (!note || note.hidden || !check || check.checked) return;
    event.preventDefault(); event.stopImmediatePropagation();
    document.getElementById('tatum-outlet-error').hidden = false;
    check.focus();
  }
  document.addEventListener('change', update);
  window.addEventListener('click', event => {
    const trigger = 'button[name="add"],input[name="add"],.product-form__submit,.shopify-payment-button__button';
    // YMQ makes the native button pointer-events:none and handles its parent span.
    // Capture on window so this runs before YMQ's wrapper/document listeners.
    const direct = event.target.closest(trigger);
    const wrapper = event.target.closest('span');
    if (direct || wrapper?.querySelector(':scope > button[name="add"]')) gate(event);
  }, true);
  window.addEventListener('submit', event => {if(event.target.matches('form[action*="/cart/add"]')) gate(event);}, true);
  window.addEventListener('invalid', event => {if (event.target.id === 'tatum-outlets-confirmed') document.getElementById('tatum-outlet-error').hidden = false;}, true);
  const observer = new MutationObserver(records => {
    // Ignore our own insertions/text to avoid a render loop. Watch YMQ rerenders.
    if (!records.some(r => !r.target.closest?.('.tatum-option-note'))) return;
    if (!queued) {queued = true; requestAnimationFrame(update);}
  });
  observer.observe(document.body, {subtree:true,childList:true});
  update();
})();
